import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js';

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

interface IMvItem {
  date: string;
  hour: number;
  mv: number;
  max_mv: number;
  pl: number;
  dtlt: string;
}

interface PeakPowerChartProps {
  mvData: IMvItem[];
}

const PeakPowerChart: React.FC<PeakPowerChartProps> = ({ mvData }) => {
  if (!mvData || mvData.length === 0) return null; // Safety check

  const allZero = mvData.every((item) => item.max_mv === 0);
  if (allZero) return null;
  console.log(mvData);
  // const labels = mvData.map((item) => `${item.date} ${item.hour}:00`);
  const data = {
    labels: mvData.map((item) =>
      new Date(item.dtlt).toLocaleDateString('en-US', {
        year: 'numeric',
        day: 'numeric',
        month: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      })
    ),
    datasets: [
      {
        label: 'Peak Power (kW)',
        data: mvData.map((item) => item.max_mv),
        borderColor: '#528498', // Blue for power
        backgroundColor: '#d3e3ea',
        borderWidth: 1,
        categoryPercentage: 1.0,
        barPercentage: 1.0,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
        position: 'top' as const,
        labels: {
          font: {
            size: 20, // Adjust font size
            // weight: 'bold' as const,
          },
          color: '#006087',
        },
      },
      tooltip: {
        mode: 'index' as const,
        intersect: false,
      },
    },
    scales: {
      x: {
        title: {
          display: false,
          text: 'Time',
        },
        ticks: {
          autoSkip: true,
          maxTicksLimit: 8,
          color: '#006087',
          minRotation: 10,
          maxRotation: 40,
        },
        grid: {
          color: '#d2e3ea6a',
        },
      },
      y: {
        title: {
          display: false,
          text: 'Peak Power (kW)',
          color: '#006087',
        },
        grid: {
          color: '#d2e3ea6a',
        },
        ticks: {
          color: '#006087',
        },
        beginAtZero: true,
      },
    },
  };

  return (
    <div className='mt-6 overflow-x-auto'>
      <div style={{ minWidth: '800px', height: '500px' }}>
        <Bar data={data} options={chartOptions} />
      </div>
    </div>
  );
};

export default PeakPowerChart;
